





















































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { meetingCategoryMap, meetingCategoryMapFull, meetingGoalMap } from '@/utils/meeting';
import { commitRealMeetingInfo } from '@/api/meeting';
import timeRangePick from '@/components/meeting/timeRangePick.vue';

import selectMember from '@/components/project/selectMember.vue';

@Component({
  components: {
    timeRangePick,
    selectMember
  }
})
class meetingEdit extends Vue {
  @Prop()
  visible;

  @Prop()
  meetingTimeRange;

  @Prop()
  meetingProjectInfo;

  data: any[] = [];
  confirmLoading: boolean = false;
  label_col: number = 5;
  content_col: number = 7;
  content_col_long: number = 19;
  groupName: string = '';
  createdGroupId: string = '';

  meetingCategoryMap: object = meetingCategoryMap;
  meetingCategoryMapFull: object = meetingCategoryMapFull;

  meetingGoalMap: object = meetingGoalMap;

  groupType: number = 1; // 1-新建飞书群 ,2-关联已有飞书群

  personListTmp: Array<object> = [];

  dealTeamList: Array<object> = [];
  ICList: Array<object> = [];
  hostList: Array<object> = [];
  otherList: Array<object> = [];

  startTime: object = {};
  endTime: object = {};
  conclusion: string = '';

  pageToken: string = '';
  hasMore: boolean = true;

  groupNow: string = '';
  groupNameSearch: string = '';
  feishuFile: string = '';
  fileIsEdit: boolean = false;

  meetingUsersSelected: object = {
    1: [], // dealTeamList
    2: [], // ICList
    3: [], // hostList
    4: [], // otherList
    5: [], // 报名-贡献观点
    6: [], // 报名-旁听学习
    8: [],
    9: [], // Deal Leader
    10: [] // Deal Member
  };

  linkedGroupList: Array<object> = [];
  linkedGroupMap: Array<object> = [];
  otherGroupList: Array<object> = [];

  fetching: boolean = false;

  @Watch('visible')
  visibleChange(val) {
    // 加if判断 兼容旧数据,没有对应字段的情况
    let { name, meetingUsers, meetingCategory, startTime, endTime, realStartTime, realEndTime, companyId, conclusion } = this.meetingProjectInfo;
    if (val) {
      if (meetingUsers) {
        this.initPerson(meetingUsers);
      }
      if (conclusion) {
        this.conclusion = conclusion;
      } else {
        this.conclusion = '';
      }
      if (realStartTime) {
        this.startTime = realStartTime;
        this.endTime = realEndTime;
      } else if (startTime) {
        this.startTime = startTime;
        this.endTime = endTime;
      }
    }
  }

  mounted() {}

  get meetingUsers() {
    if (!this.meetingProjectInfo.meetingUsers) {
      return {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        8: [],
        9: [],
        10: []
      };
    }
    return {
      1: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 1),
      2: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 2),
      3: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 3),
      4: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 4),
      5: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 5),
      6: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 6),
      8: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 8),
      9: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 9),
      10: this.meetingProjectInfo.meetingUsers.filter(_ => _.type === 10)
    };
  }

  get meetingUsersFilter() {
    // 遍历meetingUsers,按分类排除掉meetingUsersSelected里的
    let meetingUsersFilter = {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
      8: [],
      9: [],
      10: []
    };
    for (let item in this.meetingUsers) {
      this.meetingUsers[item].forEach(_ => {
        if (!this.meetingUsersSelected[item].find(__ => __.id === _.id)) {
          meetingUsersFilter[item].push(_);
        }
      });
    }
    return meetingUsersFilter;
  }

  toProjectDetail(projectId) {
    window.open('/project/detail?id=' + projectId);
  }

  handleCancel() {
    this.confirmLoading = false;
    this.$emit('hide', 'cancel');
  }

  async handleOk() {
    try {
      this.confirmLoading = true;
      let meetingProjectId = this.meetingProjectInfo.meetingProjectId;
      // let attendMeetingUserList = [];
      let user: any = [];
      for (let item in this.meetingUsersSelected) {
        this.meetingUsersSelected[item].forEach(_ => {
          return user.push({
            id: _.id,
            type: item,
            realStatus: 1
          });
        });
      }
      for (let item in this.meetingUsersFilter) {
        this.meetingUsersFilter[item].forEach(_ => {
          return user.push({
            id: _.id,
            type: item,
            realStatus: 0
          });
        });
      }
      let res = await commitRealMeetingInfo({
        meetingProjectId,
        startTime: this.startTime,
        endTime: this.endTime,
        conclusion: this.conclusion,
        attendMeetingUserList: user
      });
      this.confirmLoading = false;
      if (res.code === 200) {
        this.$emit('hide', 'old');
        this.$message.success('修改成功!');
      }
    } catch (e) {
      e.message && this.$message.error(e.message);
      this.confirmLoading = false;
    }
  }

  meetingTimeChange(time) {
    this.startTime = time[0];
    this.endTime = time[1];
  }

  chosePerson(members, type) {
    members.forEach(_ => {
      _['type'] = type;
    });
    this.meetingUsersSelected[type] = members;
  }

  delPerson(user, type) {
    this.meetingUsersSelected[type] = this.meetingUsersSelected[type].filter(_ => _.id !== user.id);
  }

  initPerson(val) {
    if (val) {
      this.meetingUsersSelected[1] = val.filter(_ => _.type === 1 && _.realStatus);
      this.meetingUsersSelected[2] = val.filter(_ => _.type === 2 && _.realStatus);
      this.meetingUsersSelected[3] = val.filter(_ => _.type === 3 && _.realStatus);
      this.meetingUsersSelected[4] = val.filter(_ => _.type === 4 && _.realStatus);
      this.meetingUsersSelected[5] = val.filter(_ => _.type === 5 && _.realStatus);
      this.meetingUsersSelected[6] = val.filter(_ => _.type === 6 && _.realStatus);
      this.meetingUsersSelected[8] = val.filter(_ => _.type === 8 && _.realStatus);
      this.meetingUsersSelected[9] = val.filter(_ => _.type === 9 && _.realStatus);
      this.meetingUsersSelected[10] = val.filter(_ => _.type === 10 && _.realStatus);
    } else {
      this.meetingUsersSelected[1] = [];
      this.meetingUsersSelected[2] = [];
      this.meetingUsersSelected[3] = [];
      this.meetingUsersSelected[4] = [];
      this.meetingUsersSelected[5] = [];
      this.meetingUsersSelected[6] = [];
      this.meetingUsersSelected[8] = [];
      this.meetingUsersSelected[9] = [];
      this.meetingUsersSelected[10] = [];
    }
  }

  addSuggest(type, val) {
    this.meetingUsersSelected[type] = [...this.meetingUsersSelected[type], val];
  }
}
export default meetingEdit;
